import React from "react";
import Chart from "react-apexcharts";

const PersistanceChart = () => {
  const options = {
    chart: {
      type: "radialBar",
    },
    plotOptions: {
      radialBar: {
        hollow: { size: "60%" },
        track: { background: "#333" },
        dataLabels: {
          name: { show: false },
          value: { color: "#fff", fontSize: "16px", fontWeight: "bold" },
        },
      },
    },
    colors: ["#1FA4E2"], 
  };

  const series = [75]; 

  return (
    <div className="text-white text-center flex items-center justify-center">
      <Chart options={options} series={series} type="radialBar" width={125} height={120} />
      <p className="font-semibold">Persistence</p>
    </div>
  );
};

export default PersistanceChart;
